import { _ } from "libs";
import React from "react";
import { Reservation } from "../types";
import moment from "moment-timezone";
import ReservationItemLarge from "./items/reservation/large";
import ReservationItemCompact from "./items/reservation/compact";
import NoResults from "./noResults";
import { Link } from "react-router-dom";
// import { prettyDate } from "../actions/prettyDate";
import cx from "classnames";

type OnSelect = (reservation: Reservation) => void;

const ReservationItem = ({
	reservation,
	userId,
	compact = false,
	className,
}: {
	reservation: Reservation;
	userId: string;
	compact: Boolean;
	className?: string;
}) => {
	const timezone = reservation.club.clubInfo.timeZone;
	const date = moment.unix(reservation.startDateTime).tz(timezone);
	var partners = [];
	reservation.players.forEach(function (player) {
		if (player.playerId !== userId) {
			partners.push(player);
		}
	});
	
	if(compact) {
		return (
			<ReservationItemCompact
				date={date}
				club={reservation.club.clubInfo.name}
				court={reservation.court.name}
				sport={reservation.court.sport}
				partners={partners}
				className={className}
			/>
		);
	} else {
		return (
			<ReservationItemLarge
				date={date}
				club={reservation.club.clubInfo.name}
				court={reservation.court.name}
				sport={reservation.court.sport}
				partners={partners}
				className={className}
			/>
		);
	}
};

const ReservationsList = ({
	selectedReservation,
	reservations,
	onSelect = null,
	userId,
	dashboardMode = false,
	loading = false,
}: {
	selectedReservation?: Reservation;
	reservations: Reservation[];
	onSelect?: OnSelect;
	userId: string;
	dashboardMode?: boolean;
	loading: boolean;
}) => {
	return (
		<div className="table reservations">
			{reservations.length > 0
				? reservations.map((reservation, index) => {
						let selected = false;
						if (selectedReservation) {
							selected = selectedReservation.reservationId === reservation.reservationId;
						}

						if (dashboardMode) {
							return (
								<Link
									to={`/reservations/active/${reservation.reservationId}`}
									key={reservation.reservationId}
									className={cx("cell", "capsule", { selected: selected })}
									onClick={(e) => (onSelect ? onSelect(reservation) : null)}
								>
									<ReservationItem reservation={reservation} userId={userId} compact={true} />
								</Link>
							);
						}

						return (
							<div
								className={`cell clickable ${selected ? "selected" : ""}`}
								onClick={() => (onSelect ? onSelect(reservation) : null)}
								key={reservation.reservationId}
							>
								<ReservationItem reservation={reservation} userId={userId} compact={false} />
							</div>
						);
				  })
				: dashboardMode
				? null
				: !loading && <NoResults text={_("reservations.noResults")} />}
		</div>
	);
};

export default ReservationsList;
